import { DemDetailComponent } from './../tools/dem-downloader/dem-detail/dem-detail.component';
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  ViewContainerRef,
  ComponentFactoryResolver,
  ChangeDetectorRef,
  HostListener,
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

import { InformationComponent } from '../tools/information/information.component';
import { ZoomComponent } from '../tools/annotation/zoom/zoom.component';
import { EditAnnotationRightComponent } from '../tools/annotation/edit-annotation-right/edit-annotation-right.component';
import { MapServiceService } from '../../services/Map-service/map-service.service';
import { SideNavService } from '../../services/sidenav/side-nav.service';
import { FeatureNameComponent } from '../tools/feature-name/feature-name.component';
import { FeaturesListComponent } from '../tools/features-list/features-list.component';

@Component({
  //added for error
  // changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-side-panels',
  templateUrl: './side-panels.component.html',
  styleUrls: ['./side-panels.component.css'],
})
export class SidePanelsComponent implements OnInit {
  @ViewChild('leftSidenav', { static: true }) public sidenav!: MatSidenav;
  @ViewChild('rightSideNav', { static: true }) public rightSideNav!: MatSidenav;

  @Input() openNav: boolean | undefined;
  @ViewChild('container', { read: ViewContainerRef }) viewContainerRef:
    | ViewContainerRef
    | undefined;

  @ViewChild('Rightcontainer', { read: ViewContainerRef }) Rightcontainer:
    | ViewContainerRef
    | undefined;

  constructor(
    public sidenavService: SideNavService,
    private cdref: ChangeDetectorRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    public mapService: MapServiceService
  ) { }
  menu: any;
  hideHeader: any;
  ref: any;
  rightRef: any;
  rightFactory: any;
  factory: any;
  toolName: any;
  url: any;
  rightPanelData?: any[] = [];
  previousMenu: any;
  menu1: any;
  previousInfoMenu: any;
  currentZoom: any;
  tools: any;
  HideForEmbed = 'false';
  sidenavWidth: any = 200
  defaultView: any = false
  ngOnInit(): void {
    this.mapService.hideHeader.subscribe((res: any) => {
      this.defaultView = res;
    });


    this.sidenavService.setSidenav(this.sidenav);
    this.sidenavService.setRightSidenav(this.rightSideNav);
    this.HideForEmbed = this.mapService.embed;
    this.sidenavService.activeTool.subscribe((res: any) => {
      this.toolName = res.name;
      this.url = res.url;
    });


    if (this.tools) {
      this.sidenavService.leftSideNavState('open');
    }
    //to render any component from left panel
    this.sidenavService.leftMenu.subscribe((value: any) => {
      this.menu = value;
      if (this.ref) {
        this.ref.destroy();
      }
      this.renderLeftComponent(this.menu.data);
    });
    //to render any component from right panel
    this.sidenavService.rightMenu.subscribe((value: any) => {
      this.menu1 = value;

      if (this.rightRef) {
        this.rightRef.destroy();
      }
      this.renderRightComponent(this.menu1);
    });
    this.sidenavService.samePanelSize.subscribe((value: any) => {
      if (value == true) {
        if (!this.mapService.panelSize) {
          const fontSize = 12
          switch (fontSize as any) {
            case '12':
              this.sidenavWidth = 200
              break;
            default:
              this.sidenavWidth = 200
          }
        } else {
          this.sidenavWidth = 250
        }
      } else {
        this.sidenavWidth = 200
      }

    })



    this.mapService.hideHeader.subscribe((res: any) => {
      this.hideHeader = res;
    });
    //for testing
    // this.hideHeader = true
  }

  //rendering left side panel components
  renderLeftComponent(data: any): void {
    this.onResize();
    if (data.component == null) {
      this.sidenavService.close();
      this.sidenavService.leftSideNavState('closed');
      return;
    } else {
      if (data.displayName === 'Zoom Box') {
        this.mapService.zoomType = 'Circle';
      } else if (data.displayName === 'Google Street View') {
        this.mapService.type = 'Point';
      } else if (data.displayName === 'Bookmark') {
        this.mapService.bookMarkType = 'Point';
      }
      this.factory = this.componentFactoryResolver.resolveComponentFactory(
        data.component
      );
      this.ref = this.viewContainerRef?.createComponent(this.factory);
      if (data.show == 'true') {
        this.sidenavService.clickedTool(data.displayName, data.iconName);
        this.sidenavService.open();
      } else {
        this.sidenavService.close();
        this.sidenavService.leftSideNavState('closed');
      }
    }
  }
  //comparing two objects
  objectsEqual = (o1: any, o2: any) => {
    if (o1 && o2) {
      return (
        Object.keys(o1).length === Object.keys(o2).length &&
        Object.keys(o1).every((p) => o1[p] === o2[p])
      );
    } else {
      return false;
    }
  };

  //rendering right side panel components
  renderRightComponent(data: any): void {
    //checking if sidenav is already opened
    this.onResize();
    if (this.rightSideNav.opened) {
      this.sidenavService.showAnimateNow = true;
    } else {
      this.sidenavService.showAnimateNow = false;
    }
    if (data.component == FeatureNameComponent || data.component == FeaturesListComponent) {
      this.sidenavService.panelSize(true);
    } else {
      this.sidenavService.panelSize(false);
    }
    //for destroying feature list but to hover dont destroy on ngdestroy and check if new anno is not created
    if (
      (data.component == InformationComponent ||
        data.component == ZoomComponent ||
        data.component == EditAnnotationRightComponent ||
        data.Component == DemDetailComponent) &&
      !this.sidenavService.newAnnoCreated
    ) {
      //to destroy feature list features
      this.sidenavService.activeFeatureList = [];
      if (this.mapService.result) {
        this.mapService.result.getSource().clear();
        this.sidenavService.saveFeatureListData = [];
      }
    }
    if (data.component == null) {
      this.sidenavService.closeRightSideNav();
      return;
    } else if (data.history == false && data.push == true) {
      const data1 = this.sidenavService.rightPanelComponentHistory;
      if (data1?.length) {
        //saving history if not duplicate i.e last data and upcoming data
        if (!this.objectsEqual(data1[data1?.length - 1].data, data.data)) {
          this.sidenavService.rightPanelComponentHistory.push({
            id: data?.id,
            component: data.component,
            data: data.data,
            push: data.push,
          });
        }
      }
      //saving for the first time
      else {
        this.sidenavService.rightPanelComponentHistory.push({
          id: data?.id,
          component: data.component,
          data: data.data,
          push: data.push,
        });
      }
      //splicing after render history component
    } else if (data.history == true) {
      if (!this.sidenavService.FeatureListsplice) {
        //addition checks to maintain featureList featureName history pattern

        setTimeout(() => {
          this.sidenavService.rightPanelComponentHistory.splice(
            this.sidenavService.rightPanelComponentHistory.length - 2,
            1
          );
        }, 100);
      } else {
        setTimeout(() => {
          this.sidenavService.rightPanelComponentHistory.splice(
            this.sidenavService.rightPanelComponentHistory.length - 1,
            1
          );
        }, 100);
      }
    }
    //passing data to right panel component
    if (data.data) {
      this.sidenavService.dataPassToRightPanel = data.data;
    } else {
      this.sidenavService.dataPassToRightPanel = [];
    }

    this.rightFactory = this.componentFactoryResolver.resolveComponentFactory(
      data.component
    );

    this.rightRef = this.Rightcontainer?.createComponent(this.rightFactory);
    if (data.componenet != InformationComponent) {
      this.sidenavService.informationIsLoaded = false;
      // this.sidenavService.showAnimateNow = false;
    }
    this.sidenavService.openRightSideNav();
    // if (!this.rightSideNav.opened) {
    //   this.sidenavService.openRightSideNav();
    // }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.sidenavService.onResize();
  }

  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }
}
